// import React, { useState, useRef, useEffect, useCallback } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import SearchIcon from "@mui/icons-material/Search";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import debounce from "lodash.debounce";
// import axiosClient from "../../../axios-client";
// import {
//   setBwvSearchQuery,
//   setSearchText,
//   setCurrentPage,
//   setRadius,
//   setSearchTerm,
// } from "../../../redux/slices/bwvSlice";
// import {
//   RiFolderFill,
//   RiBriefcaseFill,
//   RiAdvertisementFill,
//   RiHome4Fill,
//   RiStoreFill,
//   RiHeartFill,
//   RiStarFill,
//   RiCalendarFill,
//   RiTShirtFill,
//   RiCarFill,
//   RiPlayCircleFill,
//   RiMicFill,
//   RiUserLocationFill,
//   RiTentFill,
//   RiHeadphoneFill,
//   RiProductHuntFill,
//   RiTreasureMapFill,
//   RiBrushFill,
//   RiGovernmentFill,
// } from "react-icons/ri";
// import "./searchLca.css";
// import {
//   fetchItems,
//   fetchCategories,
//   fetchSubCategories,
//   postRequest,
// } from "../Data";
// import {
//   checkExisting,
//   setActionType,
//   setInquiryNeedOpen,
// } from "../../../redux/slices/SearchBarSlice";
// import { setEngagedCouple } from "../../../redux/slices/RequestFormSlice";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";

// // API call for suggestions
// const fetchSuggestion = async (query) => {
//   try {
//     const res = await axiosClient.get(`services/searchSuggetion/${query}`);
//     if (res.data.statusCode === 200) return res.data.Data || [];
//     return [];
//   } catch (err) {
//     console.error("Error fetching suggestions:", err);
//     return [];
//   }
// };

// // Icon helpers
// const getIconForName = (name) => {
//   if (!name) return <RiFolderFill />;
//   const n = name.toLowerCase();
//   if (n === "job market") return <RiBriefcaseFill />;
//   if (n === "real estate") return <RiHome4Fill />;
//   if (n === "local business ads") return <RiStoreFill />;
//   if (n === "highlight") return <RiStarFill />;
//   if (n === "matrimony") return <RiHeartFill />;
//   if (n === "event businesses & customers") return <RiCalendarFill />;
//   return <RiFolderFill />;
// };

// const getVendorIcon = (name) => {
//   if (!name) return <RiFolderFill />;
//   const n = name.toLowerCase();
//   if (n.includes("photography")) return <RiStarFill />;
//   if (n.includes("venue")) return <RiHome4Fill />;
//   if (n.includes("catering") || n.includes("cuisine")) return <RiStoreFill />;
//   if (n.includes("decoration")) return <RiHeartFill />;
//   if (n.includes("music")) return <RiCalendarFill />;
//   if (n.includes("clothing")) return <RiTShirtFill />;
//   if (n.includes("ads")) return <RiAdvertisementFill />;
//   if (n.includes("transportation")) return <RiCarFill />;
//   if (n.includes("dance")) return <RiPlayCircleFill />;
//   if (n.includes("mc/host")) return <RiMicFill />;
//   if (n.includes("turban")) return <RiUserLocationFill />;
//   if (n.includes("tent")) return <RiTentFill />;
//   if (n.includes("planning")) return <RiCalendarFill />;
//   if (n.includes("dj")) return <RiHeadphoneFill />;
//   if (n.includes("gurudwara") || n.includes("temple"))
//     return <RiGovernmentFill />;
//   if (n.includes("hair") || n.includes("makeup")) return <RiProductHuntFill />;
//   if (n.includes("jewelry")) return <RiTreasureMapFill />;
//   if (n.includes("mehndi")) return <RiBrushFill />;
//   return <RiFolderFill />;
// };

// const SearchBwv = () => {
//   const dispatch = useDispatch();
//   const { bwvSearchQuery, searchTerm } = useSelector(
//     (state) => state.bwvData || {}
//   );
//   const userinfo = useSelector((state) => state.user.userInfo);
//   const islogin = useSelector((state) => state.user.isLogin);
//   const user = islogin ? JSON.parse(userinfo) : null;
//   const isAdmin = user?.Role === "admin";
//   const isVendor = user?.Role === "provider";

//   const [adsCategories, setAdsCategories] = useState([]);
//   const [vendorCategories, setVendorCategories] = useState([]);
//   const [productSubCat, setProductSubCat] = useState([]);
//   const [items, setItems] = useState([]);
//   const [suggestions, setSuggestions] = useState([]);
//   const [zipSuggestions, setZipSuggestions] = useState([]);
//   const [isFetchingSuggestions, setIsFetchingSuggestions] = useState(false);
//   const [zipLoading, setZipLoading] = useState(false);
//   const [activeInput, setActiveInput] = useState(null);
//   const [displayValue, setDisplayValue] = useState(""); // Input display

//   const navigate = useNavigate();
//   const location = useLocation();
//   const wrapperRef = useRef(null);
//   const API_KEY = "b8781580fead40ca9de977a25ea50d16"; // Same as SearchLca
//   const isMajesticHome =location.hash?.toLowerCase().includes("majestichomepage") ||location.pathname?.toLowerCase().includes("majestichomepage");

//   // Close dropdowns on outside click
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
//         setActiveInput(null);
//         setZipSuggestions([]);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Load categories
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [category, subCategories, itemsData] = await Promise.all([
//           fetchCategories(),
//           fetchSubCategories(),
//           fetchItems(),
//         ]);
//         const filterCategoryByName = category.filter((cat) => cat.Id === 1);
//         const filterSubCat = subCategories.filter(
//           (subCat) => subCat.CategoryId === filterCategoryByName[0]?.Id
//         );
//         const filterItems = itemsData.filter((item) =>
//           filterSubCat.some((subCat) => item.subCatId === subCat.id)
//         );
//         const safeSubCats = Array.isArray(filterSubCat) ? filterSubCat : [];
//         const safeItems = Array.isArray(filterItems) ? filterItems : [];

//         setProductSubCat(safeSubCats);
//         setItems(safeItems);
//         setVendorCategories(Array.isArray(category) ? category : []);
//         setAdsCategories(safeSubCats.slice(0, 6));
//       } catch (err) {
//         console.error("Error fetching data:", err);
//       }
//     };
//     fetchData();
//   }, []);

//   // Sync displayValue with searchTerm (from Redux)
//   useEffect(() => {
//     if (!searchTerm) {
//       setDisplayValue("");
//     }
//   }, [searchTerm]);

//   // Fetch zip suggestions
//   useEffect(() => {
//     const fetchZipSuggestions = async () => {
//       if (!searchTerm || searchTerm.length < 3) {
//         setZipSuggestions([]);
//         return;
//       }
//       setZipLoading(true);
//       try {
//         const res = await axios.get(
//           `https://api.geoapify.com/v1/geocode/autocomplete`,
//           {
//             params: {
//               text: searchTerm,
//               apiKey: API_KEY,
//               type: "postcode",
//               filter: "countrycode:us",
//             },
//           }
//         );

//         const options = res.data.features
//           .map((f) => {
//             const p = f.properties;
//             const zip = p.postcode?.split("-")[0];
//             return {
//               zip,
//               cityName: p.city,
//               state: p.state,
//               display: `${zip} - ${p.city}, ${p.state}`,
//             };
//           })
//           .filter((v, i, a) => a.findIndex((t) => t.zip === v.zip) === i);

//         setZipSuggestions(options);
//       } catch (err) {
//         console.error("Geoapify error:", err);
//       } finally {
//         setZipLoading(false);
//       }
//     };

//     const delay = setTimeout(fetchZipSuggestions, 400);
//     return () => clearTimeout(delay);
//   }, [searchTerm]);

//   // Category filtering
//   const uniqueAdsCategories = Array.from(
//     new Map(
//       adsCategories.map((cat) => [cat.subCatName || cat.Name, cat])
//     ).values()
//   );

//   const filterCategories = (query, categories) => {
//     if (!query || query.length < 3) return categories;
//     const q = query.toLowerCase();
//     return categories.filter((cat) => {
//       const label = (cat.subCatName || cat.Name || "").toLowerCase();
//       return label.includes(q);
//     });
//   };

//   const filteredAdsCategories = filterCategories(
//     bwvSearchQuery || "",
//     uniqueAdsCategories
//   );
//   const filteredVendorCategories = filterCategories(
//     bwvSearchQuery || "",
//     vendorCategories
//   );

//   // Debounced text suggestions
//   const debouncedFetchSuggestions = useCallback(
//     debounce(async (query) => {
//       if (query.length >= 3) {
//         setIsFetchingSuggestions(true);
//         const data = await fetchSuggestion(query);
//         setSuggestions(data);
//         setIsFetchingSuggestions(false);
//       } else {
//         setSuggestions([]);
//       }
//     }, 400),
//     []
//   );

//   useEffect(() => {
//     if (bwvSearchQuery) debouncedFetchSuggestions(bwvSearchQuery);
//     else setSuggestions([]);
//     return () => debouncedFetchSuggestions.cancel();
//   }, [bwvSearchQuery, debouncedFetchSuggestions]);

//   // URL sync
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const categoryFromUrl = params.get("categoryName");
//     if (categoryFromUrl) {
//       dispatch(setBwvSearchQuery(categoryFromUrl));
//       dispatch(setSearchText(categoryFromUrl));
//     }
//   }, [location.search, dispatch]);

//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     if (!params.get("categoryName")) {
//       dispatch(setBwvSearchQuery(""));
//       dispatch(setSearchText(""));
//     }
//   }, [location.pathname, dispatch]);

//   const handleCategorySelect = (name) => {
//       if (isMajesticHome) {
//       navigate(`/weddingvendors?selected=vendors-grid&categoryName=${encodeURIComponent(name)}`);
//         return;
//     }
//     dispatch(setBwvSearchQuery(name));
//     dispatch(setSearchText(name));
//     dispatch(setCurrentPage(1));
//     setActiveInput(null);
//     submitRequest();
//     const params = new URLSearchParams(location.search);
//     params.set("categoryName", name);
//     navigate(`?${params.toString()}`, { replace: true });
//   };

//   const handleSuggestionSelect = async (title) => {
//      if (isMajesticHome) {
//        navigate(`/weddingvendors?selected=vendors-grid&categoryName=${encodeURIComponent(title)}`);
//         return;
//     }
//     dispatch(setBwvSearchQuery(title));
//     dispatch(setSearchText(title));
//     dispatch(setCurrentPage(1));
//     setActiveInput(null);
//     await submitRequest();
//   };

//   const handleZipSelect = (suggestion) => {
//     dispatch(setSearchTerm(suggestion.zip)); // Store only zip
//     setDisplayValue(suggestion.display); // Show full text
//     setZipSuggestions([]); // Hide dropdown
//     setActiveInput(null);
//   };

//   const handleZipInputChange = (e) => {
//     const value = e.target.value.replace(/\D/g, ""); // Only digits
//     dispatch(setSearchTerm(value));
//     dispatch(setRadius(15));
//     setDisplayValue(value);
//   };

//   const clearZip = () => {
//     dispatch(setSearchTerm(""));
//     dispatch(setRadius(15));
//     setDisplayValue("");
//     setZipSuggestions([]);
//   };

//   const handleSearch = async () => {
//     if (!bwvSearchQuery && !searchTerm) return;
//      if (isMajesticHome) {
//          navigate(`/weddingvendors?selected=vendors-grid&categoryName=${encodeURIComponent(bwvSearchQuery)}`);
//         return;
//     }
//     dispatch(setCurrentPage(1));
//     if (bwvSearchQuery) dispatch(setSearchText(bwvSearchQuery));
//     setActiveInput(null);
//     await submitRequest();
//   };

//   const submitRequest = async () => {
//     const formData = localStorage.getItem("EnquiryFormData");
//     const parsedFormData = formData ? JSON.parse(formData) : {};
//     if (isAdmin || isVendor || !islogin) return;

//     let needExists = false;
//     if (islogin) {
//       const checkForm = {
//         Title: `${bwvSearchQuery} (Auto Generated)`,
//         userId: user.UserID,
//       };
//       const result = await dispatch(checkExisting(checkForm)).unwrap();
//       needExists = result.data;
//     }
//     if (needExists) return;

//     if (!parsedFormData || Object.keys(parsedFormData).length === 0) {
//       dispatch(setInquiryNeedOpen(true));
//       dispatch(setActionType("SEARCH"));
//       dispatch(setEngagedCouple(1));
//       return;
//     }

//     const requestData = {
//       ...parsedFormData,
//       ...(parsedFormData.availableFrom &&
//         typeof parsedFormData.availableFrom !== "string" && {
//           availableFrom: JSON.stringify(parsedFormData.availableFrom),
//         }),
//       Title: `${bwvSearchQuery} (Auto Generated)`,
//       createdBy: user?.UserID || null,
//       engagedCouple: 1,
//       otherVendors: [],
//     };
//     await postRequest(requestData);
//   };

//   return (
//     <div ref={wrapperRef} className="searchLca-bar-container">
//       <div className="search-bar">
//         <div className="split-input">
//           <div className="category-input-wrapper">
//             <div className="input-with-icon">
//               <SearchIcon className="search-icon" />
//               <input
//                 type="text"
//                 className="split-part"
//                 placeholder="Search"
//                 value={bwvSearchQuery || ""}
//                 onChange={(e) => {
//                   dispatch(setBwvSearchQuery(e.target.value));
//                   setActiveInput("category");
//                 }}
//                 onFocus={() => setActiveInput("category")}
//               />
//               {bwvSearchQuery && (
//                 <span
//                   className="clear-btn"
//                   onClick={() => {
//                     dispatch(setBwvSearchQuery(""));
//                     dispatch(setSearchText(""));
//                     setSuggestions([]);
//                     const params = new URLSearchParams(location.search);
//                     params.delete("categoryName");
//                     navigate(`?${params.toString()}`, { replace: true });
//                     setActiveInput(null);
//                   }}
//                 >
//                   x
//                 </span>
//               )}
//             </div>
//           </div>

//           <div className="divider" />
//           <div
//             className="location-input-wrapper"
//             style={{ position: "relative" }}
//           >
//             <div className="input-with-icon">
//               <LocationOnIcon className="search-icon" />
//               <input
//                 type="text"
//                 className="split-part"
//                 placeholder="Zipcode, City"
//                 value={displayValue}
//                 onChange={handleZipInputChange}
//                 onFocus={() => setActiveInput("zip")}
//                 onKeyDown={(e) => {
//                   if ((e.keyCode < 48 || e.keyCode > 57) && e.keyCode !== 8) {
//                     e.preventDefault();
//                   }
//                 }}
//               />
//               {displayValue && (
//                 <span className="clear-btn" onClick={clearZip}>
//                   x
//                 </span>
//               )}
//             </div>

//             {zipLoading && (
//               <div
//                 className="text-center mt-2 fs-6"
//                 style={{ position: "absolute" }}
//               >
//                 Loading...
//               </div>
//             )}
//             {zipSuggestions.length > 0 && activeInput === "zip" && (
//               <ul
//                 style={{
//                   listStyle: "none",
//                   padding: 0,
//                   margin: "4px 0 0",
//                   border: "1px solid #ccc",
//                   borderRadius: "6px",
//                   maxHeight: "200px",
//                   overflowY: "auto",
//                   background: "#fff",
//                   position: "absolute",
//                   width: "100%",
//                   zIndex: 100,
//                   boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
//                 }}
//               >
//                 {zipSuggestions.map((s, i) => (
//                   <li
//                     key={i}
//                     onClick={() => handleZipSelect(s)}
//                     style={{
//                       padding: "8px 10px",
//                       cursor: "pointer",
//                       borderBottom:
//                         i < zipSuggestions.length - 1
//                           ? "1px solid #eee"
//                           : "none",
//                     }}
//                     onMouseEnter={(e) =>
//                       (e.target.style.backgroundColor = "#f5f5f5")
//                     }
//                     onMouseLeave={(e) =>
//                       (e.target.style.backgroundColor = "#fff")
//                     }
//                   >
//                     {s.display}
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </div>
//         </div>
//         <button type="button" className="search-btn" onClick={handleSearch}>
//           Search
//         </button>
//         {activeInput === "category" && (
//           <ul className="cat-dropdown category-dropdown">
//             <div className="dropdown-wrapper">
//               {isFetchingSuggestions ? (
//                 <li className="no-results">Loading...</li>
//               ) : suggestions.length > 0 ? (
//                 <div className="dropdown-section">
//                   <h6>Suggestions</h6>
//                   {suggestions.map((s, i) => (
//                     <li
//                       key={`sugg-${i}`}
//                       onClick={() => handleSuggestionSelect(s.Title)}
//                     >
//                       <SearchIcon fontSize="small" style={{ marginRight: 6 }} />
//                       {s.Title}
//                     </li>
//                   ))}
//                   <hr className="divider" />
//                 </div>
//               ) : null}

//               {(filteredVendorCategories.length > 0 ||
//                 filteredAdsCategories.length > 0) && (
//                 <div className="dropdown-sections">
//                   {filteredVendorCategories.length > 0 && (
//                     <div className="dropdown-section left-section">
//                       <h4>Vendor Categories</h4>
//                       {filteredVendorCategories.map((cat, i) => (
//                         <li
//                           key={cat.Id || i}
//                           onClick={() => handleCategorySelect(cat.Name)}
//                         >
//                           <span className="cat-icon">
//                             {getVendorIcon(cat.Name)}
//                           </span>
//                           {cat.Name}
//                         </li>
//                       ))}
//                     </div>
//                   )}

//                   {filteredVendorCategories.length > 0 &&
//                     filteredAdsCategories.length > 0 && (
//                       <div className="vertical-divider-searchbar" />
//                     )}

//                   {filteredAdsCategories.length > 0 && (
//                     <div className="dropdown-section right-section">
//                       <h4>Ads Categories</h4>
//                       {filteredAdsCategories.map((cat, i) => {
//                         const label = cat.subCatName || cat.Name || "Unnamed";
//                         return (
//                           <li
//                             key={cat.Id || i}
//                             onClick={() => handleCategorySelect(label)}
//                           >
//                             <span className="cat-icon">
//                               {getIconForName(label)}
//                             </span>
//                             {label}
//                           </li>
//                         );
//                       })}
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           </ul>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SearchBwv;
import React, { useState, useRef, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import debounce from "lodash.debounce";
import axiosClient from "../../../axios-client";
import {
  setBwvSearchQuery,
  setSelectedSubCat,
  setSelectedItem,
  setSelectedCat,
  setSearchText,
  setCurrentPage,
  setRadius,
  setSearchTerm,
} from "../../../redux/slices/bwvSlice";
import {
  RiFolderFill,
  RiBriefcaseFill,
  RiAdvertisementFill,
  RiHome4Fill,
  RiStoreFill,
  RiHeartFill,
  RiStarFill,
  RiCalendarFill,
  RiTShirtFill,
  RiCarFill,
  RiPlayCircleFill,
  RiMicFill,
  RiUserLocationFill,
  RiTentFill,
  RiHeadphoneFill,
  RiProductHuntFill,
  RiTreasureMapFill,
  RiBrushFill,
  RiGovernmentFill,
} from "react-icons/ri";
import "./searchLca.css";
import {
  fetchItems,
  fetchCategories,
  fetchSubCategories,
  postRequest,
} from "../Data";
import {
  checkExisting,
  setActionType,
  setInquiryFullOpen,
  setInquiryNeedOpen,
  setInquiryOpen,
} from "../../../redux/slices/SearchBarSlice";
import { setEngagedCouple } from "../../../redux/slices/RequestFormSlice";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { PopulateInquiry } from "../LocalCummunityAds/PopulateInquiry";

// API call for suggestions
const fetchSuggestion = async (query) => {
  try {
    const res = await axiosClient.get(`services/searchSuggetion/${query}`);
    if (res.data.statusCode === 200) return res.data.Data || [];
    return [];
  } catch (err) {
    console.error("Error fetching suggestions:", err);
    return [];
  }
};

// Icon helpers
const getIconForName = (name) => {
  if (!name) return <RiFolderFill />;
  const n = name.toLowerCase();
  if (n === "job market") return <RiBriefcaseFill />;
  if (n === "real estate") return <RiHome4Fill />;
  if (n === "local business ads") return <RiStoreFill />;
  if (n === "highlight") return <RiStarFill />;
  if (n === "matrimony") return <RiHeartFill />;
  if (n === "event businesses & customers") return <RiCalendarFill />;
  return <RiFolderFill />;
};

const getVendorIcon = (name) => {
  if (!name) return <RiFolderFill />;
  const n = name.toLowerCase();
  if (n.includes("photography")) return <RiStarFill />;
  if (n.includes("venue")) return <RiHome4Fill />;
  if (n.includes("catering") || n.includes("cuisine")) return <RiStoreFill />;
  if (n.includes("decoration")) return <RiHeartFill />;
  if (n.includes("music")) return <RiCalendarFill />;
  if (n.includes("clothing")) return <RiTShirtFill />;
  if (n.includes("ads")) return <RiAdvertisementFill />;
  if (n.includes("transportation")) return <RiCarFill />;
  if (n.includes("dance")) return <RiPlayCircleFill />;
  if (n.includes("mc/host")) return <RiMicFill />;
  if (n.includes("turban")) return <RiUserLocationFill />;
  if (n.includes("tent")) return <RiTentFill />;
  if (n.includes("planning")) return <RiCalendarFill />;
  if (n.includes("dj")) return <RiHeadphoneFill />;
  if (n.includes("gurudwara") || n.includes("temple"))
    return <RiGovernmentFill />;
  if (n.includes("hair") || n.includes("makeup")) return <RiProductHuntFill />;
  if (n.includes("jewelry")) return <RiTreasureMapFill />;
  if (n.includes("mehndi")) return <RiBrushFill />;
  return <RiFolderFill />;
};

const SearchBwv = () => {
  const dispatch = useDispatch();
  const { bwvSearchQuery, searchTerm } = useSelector(
    (state) => state.bwvData || {}
  );
  const userinfo = useSelector((state) => state.user.userInfo);
  const islogin = useSelector((state) => state.user.isLogin);
  const user = islogin ? JSON.parse(userinfo) : null;
  const isAdmin = user?.Role === "admin";
  const isVendor = user?.Role === "provider";

  const [adsCategories, setAdsCategories] = useState([]);
  const [vendorCategories, setVendorCategories] = useState([]);
  const [productSubCat, setProductSubCat] = useState([]);
  const [items, setItems] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [zipSuggestions, setZipSuggestions] = useState([]);
  const [isFetchingSuggestions, setIsFetchingSuggestions] = useState(false);
  const [zipLoading, setZipLoading] = useState(false);
  const [activeInput, setActiveInput] = useState(null);
  const [displayValue, setDisplayValue] = useState(""); // Input display

  const navigate = useNavigate();
  const location = useLocation();
  const wrapperRef = useRef(null);
  const API_KEY = "b8781580fead40ca9de977a25ea50d16"; // Same as SearchLca
  const isMajesticHome =
    location.hash?.toLowerCase().includes("majestichomepage") ||
    location.pathname?.toLowerCase().includes("majestichomepage");

  // Close dropdowns on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setActiveInput(null);
        setZipSuggestions([]);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Load categories
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [category, subCategories, itemsData] = await Promise.all([
          fetchCategories(),
          fetchSubCategories(),
          fetchItems(),
        ]);
        const filterCategoryByName = category.filter((cat) => cat.Id === 1);
        const filterSubCat = subCategories.filter(
          (subCat) => subCat.CategoryId === filterCategoryByName[0]?.Id
        );
        const filterItems = itemsData.filter((item) =>
          filterSubCat.some((subCat) => item.subCatId === subCat.id)
        );
        const safeSubCats = Array.isArray(filterSubCat) ? filterSubCat : [];
        const safeItems = Array.isArray(filterItems) ? filterItems : [];

        setProductSubCat(safeSubCats);
        setItems(safeItems);
        setVendorCategories(Array.isArray(category) ? category : []);
        setAdsCategories(safeSubCats.slice(0, 6));
      } catch (err) {
        console.error("Error fetching data:", err);
      }
    };
    fetchData();
  }, []);

  // Sync displayValue with searchTerm (from Redux)
  useEffect(() => {
    if (!searchTerm) {
      setDisplayValue("");
    }
  }, [searchTerm]);

  // Fetch zip suggestions
  useEffect(() => {
    const fetchZipSuggestions = async () => {
      if (!searchTerm || searchTerm.length < 3) {
        setZipSuggestions([]);
        return;
      }
      setZipLoading(true);
      try {
        const res = await axios.get(
          `https://api.geoapify.com/v1/geocode/autocomplete`,
          {
            params: {
              text: searchTerm,
              apiKey: API_KEY,
              type: "postcode",
              filter: "countrycode:us",
            },
          }
        );

        const options = res.data.features
          .map((f) => {
            const p = f.properties;
            const zip = p.postcode?.split("-")[0];
            return {
              zip,
              cityName: p.city,
              state: p.state,
              display: `${zip} - ${p.city}, ${p.state}`,
            };
          })
          .filter((v, i, a) => a.findIndex((t) => t.zip === v.zip) === i);

        setZipSuggestions(options);
      } catch (err) {
        console.error("Geoapify error:", err);
      } finally {
        setZipLoading(false);
      }
    };

    const delay = setTimeout(fetchZipSuggestions, 400);
    return () => clearTimeout(delay);
  }, [searchTerm]);

  // Category filtering
  const uniqueAdsCategories = Array.from(
    new Map(
      adsCategories.map((cat) => [cat.subCatName || cat.Name, cat])
    ).values()
  );

  const filterCategories = (query, categories) => {
    if (!query || query.length < 3) return categories;
    const q = query.toLowerCase();
    return categories.filter((cat) => {
      const label = (cat.subCatName || cat.Name || "").toLowerCase();
      return label.includes(q);
    });
  };

  const filteredAdsCategories = filterCategories(
    bwvSearchQuery || "",
    uniqueAdsCategories
  );
  const filteredVendorCategories = filterCategories(
    bwvSearchQuery || "",
    vendorCategories
  );

  // Debounced text suggestions
  const debouncedFetchSuggestions = useCallback(
    debounce(async (query) => {
      if (query.length >= 3) {
        setIsFetchingSuggestions(true);
        const data = await fetchSuggestion(query);
        setSuggestions(data);
        setIsFetchingSuggestions(false);
      } else {
        setSuggestions([]);
      }
    }, 400),
    []
  );

  useEffect(() => {
    if (bwvSearchQuery) debouncedFetchSuggestions(bwvSearchQuery);
    else setSuggestions([]);
    return () => debouncedFetchSuggestions.cancel();
  }, [bwvSearchQuery, debouncedFetchSuggestions]);

  // URL sync
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryFromUrl = params.get("categoryName");
    if (categoryFromUrl) {
      dispatch(setBwvSearchQuery(categoryFromUrl));
      dispatch(setSearchText(categoryFromUrl));
    }
  }, [location.search, dispatch]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (!params.get("categoryName")) {
      dispatch(setBwvSearchQuery(""));
      dispatch(setSearchText(""));
    }
  }, [location.pathname, dispatch]);

  const handleCategorySelect = (name) => {
    dispatch(setSelectedCat(null));
    dispatch(setSelectedSubCat(null));
    dispatch(setSelectedItem(null));
    if (isMajesticHome) {
      navigate(
        `/weddingvendors?selected=vendors-grid&categoryName=${encodeURIComponent(
          name
        )}`
      );
      return;
    }
    dispatch(setBwvSearchQuery(name));
    dispatch(setSearchText(name));
    dispatch(setCurrentPage(1));
    setActiveInput(null);
    submitRequest();
    const params = new URLSearchParams(location.search);
    params.set("categoryName", name);
    params.delete("category");
    params.delete("subCategory");
    params.delete("item");
    navigate(`?${params.toString()}`, { replace: true });
  };

  const handleSuggestionSelect = async (title) => {
    dispatch(setSelectedCat(null));
    dispatch(setSelectedSubCat(null));
    dispatch(setSelectedItem(null));
    if (isMajesticHome) {
      navigate(
        `/weddingvendors?selected=vendors-grid&categoryName=${encodeURIComponent(
          title
        )}`
      );
      return;
    }
    dispatch(setBwvSearchQuery(title));
    dispatch(setSearchText(title));
    dispatch(setCurrentPage(1));
    setActiveInput(null);
    await submitRequest();
    const params = new URLSearchParams(location.search);
    params.set("categoryName", title);
    params.delete("category");
    params.delete("subCategory");
    params.delete("item");
    navigate(`?${params.toString()}`, { replace: true });
  };

  const handleZipSelect = (suggestion) => {
    dispatch(setSearchTerm(suggestion.zip)); // Store only zip
    setDisplayValue(suggestion.display); // Show full text
    setZipSuggestions([]); // Hide dropdown
    setActiveInput(null);
  };

  const handleZipInputChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Only digits
    dispatch(setSearchTerm(value));
    dispatch(setRadius(15));
    setDisplayValue(value);
  };

  const clearZip = () => {
    dispatch(setSearchTerm(""));
    dispatch(setRadius(15));
    setDisplayValue("");
    setZipSuggestions([]);
  };

  const handleSearch = async () => {
    if (!bwvSearchQuery && !searchTerm) return;
    dispatch(setSelectedCat(null));
    dispatch(setSelectedSubCat(null));
    dispatch(setSelectedItem(null));
    if (isMajesticHome) {
      //   const params = new URLSearchParams();
      // params.set("selected", "vendors-grid");
      // if (bwvSearchQuery) params.set("categoryName", encodeURIComponent(bwvSearchQuery));
      // navigate(`/weddingvendors?${params.toString()}`);
      navigate(
        `/weddingvendors?selected=vendors-grid&categoryName=${encodeURIComponent(
          bwvSearchQuery
        )}`
      );
      return;
    }
    dispatch(setCurrentPage(1));
    if (bwvSearchQuery) dispatch(setSearchText(bwvSearchQuery));
    setActiveInput(null);
    await submitRequest();
  };

  const submitRequest = async () => {
    const formData = localStorage.getItem("EnquiryFormData");
    const parsedFormData = formData ? JSON.parse(formData) : {};
    if (isAdmin || isVendor || !islogin) return;

    let needExists = false;
    let enquiryData = null;
    let enquiryStep = null;
    if (islogin) {
      const checkForm = {
        Title: `${bwvSearchQuery} (Auto Generated)`,
        userId: user.UserID,
      };
      const result = await dispatch(checkExisting(checkForm)).unwrap();
      needExists = result?.data;
      enquiryData = result?.dataStep;
      enquiryStep = result?.dataStep?.enquiryStep;
    }
    if (needExists) return;
    if (enquiryStep > 0) {
      PopulateInquiry(enquiryData, dispatch);
    }
    if (enquiryData && enquiryStep >= 4) {
      const final = {
        ...enquiryData,
        Title: bwvSearchQuery.trim() + " (Auto Generated)",
      };
      await postRequest(final);
    } else {
      dispatch(setInquiryFullOpen(true));
      dispatch(setActionType("SEARCH"));
    }
    // if (!parsedFormData || Object.keys(parsedFormData).length === 0) {
    //   dispatch(setInquiryNeedOpen(true));
    //   dispatch(setActionType("SEARCH"));
    //   dispatch(setEngagedCouple(1));
    //   return;
    // }

    // const requestData = {
    //   ...parsedFormData,
    //   ...(parsedFormData.availableFrom &&
    //     typeof parsedFormData.availableFrom !== "string" && {
    //       availableFrom: JSON.stringify(parsedFormData.availableFrom),
    //     }),
    //   Title: `${bwvSearchQuery} (Auto Generated)`,
    //   createdBy: user?.UserID || null,
    //   engagedCouple: 1,
    //   otherVendors: [],
    // };
    // await postRequest(requestData);
  };

  return (
    <div ref={wrapperRef} className="searchLca-bar-container">
      <div className="search-bar">
        <div className="split-input">
          <div className="category-input-wrapper">
            <div className="input-with-icon">
              <SearchIcon className="search-icon" />
              <input
                type="text"
                className="split-part"
                placeholder="Search"
                value={bwvSearchQuery || ""}
                onChange={(e) => {
                  dispatch(setBwvSearchQuery(e.target.value));
                  setActiveInput("category");
                }}
                onFocus={() => setActiveInput("category")}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
              />
              {bwvSearchQuery && (
                <span
                  className="clear-btn"
                  onClick={() => {
                    dispatch(setSelectedCat(null));
                    dispatch(setSelectedSubCat(null));
                    dispatch(setSelectedItem(null));
                    dispatch(setBwvSearchQuery(""));
                    dispatch(setSearchText(""));
                    setSuggestions([]);
                    const params = new URLSearchParams(location.search);
                    params.delete("categoryName");
                    params.delete("category");
                    params.delete("subCategory");
                    params.delete("item");
                    navigate(`?${params.toString()}`, { replace: true });
                    setActiveInput(null);
                  }}
                >
                  x
                </span>
              )}
            </div>
          </div>

          <div className="divider" />
          <div
            className="location-input-wrapper"
            style={{ position: "relative" }}
          >
            <div className="input-with-icon">
              <LocationOnIcon className="search-icon" />
              <input
                type="text"
                className="split-part"
                placeholder="Search By Zipcode..."
                value={displayValue}
                onChange={handleZipInputChange}
                onFocus={() => setActiveInput("zip")}
                onKeyDown={(e) => {
                  if ((e.keyCode < 48 || e.keyCode > 57) && e.keyCode !== 8) {
                    e.preventDefault();
                  }
                }}
              />
              {displayValue && (
                <span className="clear-btn" onClick={clearZip}>
                  x
                </span>
              )}
            </div>

            {zipLoading && (
              <div
                className="text-center mt-2 fs-6"
                style={{ position: "absolute" }}
              >
                Loading...
              </div>
            )}
            {zipSuggestions.length > 0 && activeInput === "zip" && (
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: "4px 0 0",
                  border: "1px solid var(--theme-border)",
                  borderRadius: "6px",
                  maxHeight: "200px",
                  overflowY: "auto",
                  background: "#fff",
                  position: "absolute",
                  width: "100%",
                  color: "black",
                  zIndex: 100,
                  boxShadow: "0 2px 8px var(--theme-shadow)",
                }}
              >
                {zipSuggestions.map((s, i) => (
                  <li
                    key={i}
                    onClick={() => handleZipSelect(s)}
                    style={{
                      padding: "8px 10px",
                      cursor: "pointer",
                      borderBottom:
                        i < zipSuggestions.length - 1
                          ? `1px solid var(--theme-primary)`
                          : "none",
                    }}
                    onMouseEnter={(e) =>
                      (e.target.style.backgroundColor = "#f5f5f5")
                    }
                    onMouseLeave={(e) =>
                      (e.target.style.backgroundColor = "#fff")
                    }
                  >
                    {s.display}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
        <button type="button" className="search-btn" onClick={handleSearch}>
          Search
        </button>
        {activeInput === "category" && (
          <ul className="cat-dropdown category-dropdown">
            <div className="dropdown-wrapper">
              {isFetchingSuggestions ? (
                <li className="no-results">Loading...</li>
              ) : suggestions.length > 0 ? (
                <div className="dropdown-section">
                  <h6>Suggestions</h6>
                  {suggestions.map((s, i) => (
                    <li
                      key={`sugg-${i}`}
                      onClick={() => handleSuggestionSelect(s.Title)}
                    >
                      <SearchIcon fontSize="small" style={{ marginRight: 6 }} />
                      {s.Title}
                    </li>
                  ))}
                  <hr className="divider" />
                </div>
              ) : null}

              {(filteredVendorCategories.length > 0 ||
                filteredAdsCategories.length > 0) && (
                <div className="dropdown-sections">
                  {filteredVendorCategories.length > 0 && (
                    <div className="dropdown-section left-section">
                      <h4>Vendor Categories</h4>
                      {filteredVendorCategories.map((cat, i) => (
                        <li
                          key={cat.Id || i}
                          onClick={() => handleCategorySelect(cat.Name)}
                        >
                          <span className="cat-icon">
                            {getVendorIcon(cat.Name)}
                          </span>
                          {cat.Name}
                        </li>
                      ))}
                    </div>
                  )}

                  {filteredVendorCategories.length > 0 &&
                    filteredAdsCategories.length > 0 && (
                      <div className="vertical-divider-searchbar" />
                    )}

                  {!isMajesticHome && filteredAdsCategories.length > 0 && (
                    <div className="dropdown-section right-section">
                      <h4>Ads Categories</h4>
                      {filteredAdsCategories.map((cat, i) => {
                        const label = cat.subCatName || cat.Name || "Unnamed";
                        return (
                          <li
                            key={cat.Id || i}
                            onClick={() => handleCategorySelect(label)}
                          >
                            <span className="cat-icon">
                              {getIconForName(label)}
                            </span>
                            {label}
                          </li>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </div>
          </ul>
        )}
      </div>
    </div>
  );
};

export default SearchBwv;
